import confetti from 'canvas-confetti';

export const fireConfetti = () => {
  confetti({
    particleCount: 200,
    spread: 130,
    origin: { y: 0.6 },
    colors: ['#22c55e', '#4ade80', '#ffffff', '#f59e0b', '#3b82f6'],
    startVelocity: 45,
    gravity: 1.2,
    scalar: 1.2,
    ticks: 60,
  });
};
